module.exports = __webpack_public_path__ + "img/duck.4684dc54.png";